import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ConflictAlert } from './ConflictAlert';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null; // ou un composant de chargement
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>
  <ConflictAlert />
  {children}</>;
} 